import styled from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { breakpoints } from '@/config/layout'

export const StContainer = styled(FlexColumn)`
  @media ${breakpoints.m} {
    max-width: 600px;
  }
`

export const StButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: ${({ theme }) => theme.UI.SpacingPx.Space6};
  padding-bottom: calc(
    max(var(--safe-area-inset-bottom, 0px), 20px) +
      ${({ theme }) => theme.UI.Spacing.Space1}px
  );
  @media (${breakpoints.fromM}) {
    padding-bottom: calc(
      max(var(--safe-area-inset-bottom, 0px), 20px) +
        ${({ theme }) => theme.UI.Spacing.Space6}px
    );
  }
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  box-shadow:
    0px 0px 70px rgba(205, 208, 213, 0.15),
    0px 0px 10px rgba(170, 179, 193, 0.12);

  @media ${breakpoints.fromS} {
    position: relative;
    padding: 0;
    box-shadow: none;
  }
`
